import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 512 512" {...props}>
      <title id="Star-Full">{props.title || 'Star-Full'}</title>
      <g>
        <path d="M511.522 201.165c0 4.502-2.666 9.43-7.997 14.739l-111.506 108.752 26.409 153.596c.202 1.434.314 3.494.314 6.16 0 4.301-1.075 7.93-3.226 10.886-2.15 2.979-5.286 4.458-9.363 4.458-3.898 0-7.997-1.232-12.298-3.674l-137.939-72.508-137.916 72.508c-4.525 2.442-8.602 3.674-12.298 3.674-4.301 0-7.526-1.478-9.677-4.458-2.15-2.957-3.226-6.586-3.226-10.886 0-1.232.202-3.293.605-6.16l26.432-153.596-111.819-108.752c-5.13-5.533-7.683-10.438-7.683-14.739 0-7.571 5.734-12.298 17.203-14.134l154.223-22.422 69.104-139.775c3.898-8.4 8.915-12.589 15.053-12.589 6.16 0 11.155 4.189 15.053 12.589l69.126 139.775 154.223 22.422c11.447 1.836 17.203 6.563 17.203 14.134z" />
      </g>
    </Icon>
  )
}



// WEBPACK FOOTER //
// ./client/components/icons/starFull.js